import "./sass/style.scss";

import "./js/contact-tracking.js";
import "./js/enhancements/header-2026.js";
import "./js/index.js";
import "./js/custom.js";

// import anime from "./js/vendor/anime.min.js";
// Make anime available globally if needed
// window.anime = anime;
